import { render, staticRenderFns } from "./SelectAPatient.vue?vue&type=template&id=357f0e00"
import script from "./SelectAPatient.vue?vue&type=script&lang=js"
export * from "./SelectAPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports